<template>
  <div>
    <ul ref="tab" class="bank-type-tabs">
      <li
        v-if="creditCard && creditCard.length !== 0"
        :class="{ active: activeTab === 'credit' }"
        @click="changeTab('credit')"
      >
        {{ $t('Bao.credit_card') }}
      </li>
      <li
        v-if="getTypeList(1).length !== 0"
        :class="{ active: activeTab === 'bank' }"
        @click="changeTab('bank')"
      >
        {{ $t('Bao.bank_card_2') }}
      </li>
      <li
        v-if="getTypeList(3).length !== 0"
        :class="{ active: activeTab === 'crypto' }"
        @click="changeTab('crypto')"
      >
        {{ $t('Bao.cryptocurrency') }}
      </li>
      <li
        v-if="getTypeList(2).length !== 0"
        :class="{ active: activeTab === 'ewallet' }"
        @click="changeTab('ewallet')"
      >
        {{ $t('Bao.e_wallet') }}
      </li>
    </ul>

    <div class="content">
      <div class="my-bank-card">
        <div class="add-card">
          <button class="btn btn-secondary href-add-edit-card" @click="$router.push('/user/bank/create')">
            <span>{{ $t('Bao.new_card_or_account') }}</span>
          </button>
        </div>

        <div v-if="creditCard && creditCard.length !== 0" id="section-creditcard" class="bank-section" :class="{ active: activeTab === 'credit' }">
          <div class="bank-section-header">
            <h5>{{ $t('Bao.credit_card') }}</h5>
            <button class="btn btn-secondary href-add-edit-card" @click="$router.push('/user/bank/create')">
              <span>{{ $t('Bao.new_card_or_account') }}</span>
            </button>
          </div>
          <div class="bank-card-list">
            <div v-for="(item, key) in creditCard" :key="key" class="bank-card-item credit-card-frame">
              <div class="credit-card-box">
                <p class="credit-card-name">
                  {{ item.name }}
                </p>
                <div class="credit-num">
                  <div>****</div>
                  <div>****</div>
                  <div>****</div>
                  <div class="show-num">
                    {{ item.credit_card_number }}
                  </div>
                </div>
              </div>
              <a class="btn-card-edit" @click="showModal(item.id, 'credit')"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 0.5C3.5 0.224 3.724 0 4 0H8C8.276 0 8.5 0.224 8.5 0.5V1.5H11C11.276 1.5 11.5 1.724 11.5 2C11.5 2.276 11.276 2.5 11 2.5H1C0.724 2.5 0.5 2.276 0.5 2C0.5 1.724 0.724 1.5 1 1.5H3.5V0.5ZM1.5 3.5H10.5L9.8 13C9.78 13.28 9.548 13.5 9.267 13.5H2.733C2.452 13.5 2.22 13.28 2.2 13L1.5 3.5ZM4.5 5.5C4.5 5.224 4.276 5 4 5C3.724 5 3.5 5.224 3.5 5.5V11.5C3.5 11.776 3.724 12 4 12C4.276 12 4.5 11.776 4.5 11.5V5.5ZM6.5 5.5C6.5 5.224 6.276 5 6 5C5.724 5 5.5 5.224 5.5 5.5V11.5C5.5 11.776 5.724 12 6 12C6.276 12 6.5 11.776 6.5 11.5V5.5ZM8.5 5.5C8.5 5.224 8.276 5 8 5C7.724 5 7.5 5.224 7.5 5.5V11.5C7.5 11.776 7.724 12 8 12C8.276 12 8.5 11.776 8.5 11.5V5.5Z" fill="currentColor" /></svg>
              </a>
            </div>
          </div>
        </div>

        <div v-if="getTypeList(1).length !== 0" id="section-bank" class="bank-section" :class="{ active: activeTab === 'bank' }">
          <div class="bank-section-header">
            <h5>{{ $t('Bao.bank_card_2') }}</h5>
            <button class="btn btn-secondary href-add-edit-card" @click="$router.push('/user/bank/create')">
              <span>{{ $t('Bao.new_card_or_account') }}</span>
            </button>
          </div>
          <div class="bank-card-list">
            <div v-for="(item, key) in getTypeList(1)" :key="key" class="bank-card-item">
              <div class="bank-card-inner">
                <p>{{ item.bank_name }}</p>
                <p>{{ $t('Bao.bank_card_number_last_five') }}： {{ showOnlyFiveNum(item.card_number) }}</p>
              </div>
              <a class="btn-card-edit" @click="showModal(item.id)"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 0.5C3.5 0.224 3.724 0 4 0H8C8.276 0 8.5 0.224 8.5 0.5V1.5H11C11.276 1.5 11.5 1.724 11.5 2C11.5 2.276 11.276 2.5 11 2.5H1C0.724 2.5 0.5 2.276 0.5 2C0.5 1.724 0.724 1.5 1 1.5H3.5V0.5ZM1.5 3.5H10.5L9.8 13C9.78 13.28 9.548 13.5 9.267 13.5H2.733C2.452 13.5 2.22 13.28 2.2 13L1.5 3.5ZM4.5 5.5C4.5 5.224 4.276 5 4 5C3.724 5 3.5 5.224 3.5 5.5V11.5C3.5 11.776 3.724 12 4 12C4.276 12 4.5 11.776 4.5 11.5V5.5ZM6.5 5.5C6.5 5.224 6.276 5 6 5C5.724 5 5.5 5.224 5.5 5.5V11.5C5.5 11.776 5.724 12 6 12C6.276 12 6.5 11.776 6.5 11.5V5.5ZM8.5 5.5C8.5 5.224 8.276 5 8 5C7.724 5 7.5 5.224 7.5 5.5V11.5C7.5 11.776 7.724 12 8 12C8.276 12 8.5 11.776 8.5 11.5V5.5Z" fill="currentColor" /></svg>
              </a>
            </div>
          </div>
        </div>

        <div v-if="getTypeList(3).length !== 0" id="section-crypto" class="bank-section" :class="{ active: activeTab === 'crypto' }">
          <div class="bank-section-header">
            <h5>{{ $t('Bao.cryptocurrency') }}</h5>
            <button class="btn btn-secondary href-add-edit-card" @click="$router.push('/user/bank/create')">
              <span>{{ $t('Bao.new_card_or_account') }}</span>
            </button>
          </div>
          <div class="bank-card-list">
            <div v-for="(item, key) in getTypeList(3)" :key="key" class="bank-card-item">
              <div class="bank-card-inner">
                <p>{{ item.bank_name }}</p>
                <p>{{ $t('Bao.bank_card_number_last_five') }}： {{ showOnlyFiveNum(item.card_number) }}</p>
              </div>
              <a class="btn-card-edit" @click="showModal(item.id)"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 0.5C3.5 0.224 3.724 0 4 0H8C8.276 0 8.5 0.224 8.5 0.5V1.5H11C11.276 1.5 11.5 1.724 11.5 2C11.5 2.276 11.276 2.5 11 2.5H1C0.724 2.5 0.5 2.276 0.5 2C0.5 1.724 0.724 1.5 1 1.5H3.5V0.5ZM1.5 3.5H10.5L9.8 13C9.78 13.28 9.548 13.5 9.267 13.5H2.733C2.452 13.5 2.22 13.28 2.2 13L1.5 3.5ZM4.5 5.5C4.5 5.224 4.276 5 4 5C3.724 5 3.5 5.224 3.5 5.5V11.5C3.5 11.776 3.724 12 4 12C4.276 12 4.5 11.776 4.5 11.5V5.5ZM6.5 5.5C6.5 5.224 6.276 5 6 5C5.724 5 5.5 5.224 5.5 5.5V11.5C5.5 11.776 5.724 12 6 12C6.276 12 6.5 11.776 6.5 11.5V5.5ZM8.5 5.5C8.5 5.224 8.276 5 8 5C7.724 5 7.5 5.224 7.5 5.5V11.5C7.5 11.776 7.724 12 8 12C8.276 12 8.5 11.776 8.5 11.5V5.5Z" fill="currentColor" /></svg>
              </a>
            </div>
          </div>
        </div>

        <div v-if="getTypeList(2).length !== 0" id="section-e_wallet" class="bank-section" :class="{ active: activeTab === 'ewallet' }">
          <div class="bank-section-header">
            <h5>{{ $t('Bao.e_wallet') }}</h5>
            <button class="btn btn-secondary href-add-edit-card" @click="$router.push('/user/bank/create')">
              <span>{{ $t('Bao.new_card_or_account') }}</span>
            </button>
          </div>
          <div class="bank-card-list">
            <div v-for="(item, key) in getTypeList(2)" :key="key" class="bank-card-item credit-card-frame">
              <div class="credit-card-box">
                <p class="credit-card-name">
                  {{ item.bank_name }}
                </p>
                <p>{{ $t('Bao.bank_card_number_last_five') }}： {{ showOnlyFiveNum(item.card_number).slice(-5) }}</p>
              </div>
              <a class="btn-card-edit" @click="showModal(item.id)"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 0.5C3.5 0.224 3.724 0 4 0H8C8.276 0 8.5 0.224 8.5 0.5V1.5H11C11.276 1.5 11.5 1.724 11.5 2C11.5 2.276 11.276 2.5 11 2.5H1C0.724 2.5 0.5 2.276 0.5 2C0.5 1.724 0.724 1.5 1 1.5H3.5V0.5ZM1.5 3.5H10.5L9.8 13C9.78 13.28 9.548 13.5 9.267 13.5H2.733C2.452 13.5 2.22 13.28 2.2 13L1.5 3.5ZM4.5 5.5C4.5 5.224 4.276 5 4 5C3.724 5 3.5 5.224 3.5 5.5V11.5C3.5 11.776 3.724 12 4 12C4.276 12 4.5 11.776 4.5 11.5V5.5ZM6.5 5.5C6.5 5.224 6.276 5 6 5C5.724 5 5.5 5.224 5.5 5.5V11.5C5.5 11.776 5.724 12 6 12C6.276 12 6.5 11.776 6.5 11.5V5.5ZM8.5 5.5C8.5 5.224 8.276 5 8 5C7.724 5 7.5 5.224 7.5 5.5V11.5C7.5 11.776 7.724 12 8 12C8.276 12 8.5 11.776 8.5 11.5V5.5Z" fill="currentColor" /></svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <bank-verify-code
      ref="verifyCode"
      :visible="showVerifyPopup"
      @confirm="handleDelete"
      @close="closeVerifyPopup"
    />
  </div>
</template>

<script>
import { getMyBanks, deleteBankCard, getMyCreditCards, deleteCreditCard } from '@/api/bank'
import { showNotice, scrollToActive } from '@/utils/tool'
import bankVerifyCode from '@/components/modal/bankVerifyCode'
import '@/assets/css/bank-card.css'

export default {
  components: {
    bankVerifyCode
  },
  data() {
    return {
      list: [],
      creditCard: [],
      isEmptyBank: false,
      isEmptyCreditCard: false,
      activeTab: 'credit',
      deleteCardId: null,
      deleteCardType: null, // 'credit' | 'bank'
      showVerifyPopup: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      Promise.all([getMyBanks(), getMyCreditCards()])
        .then(([bankResponse, creditCardResponse]) => {
          if (bankResponse.data.data.length === 0) {
            this.isEmptyBank = true
          }
          this.list = bankResponse.data.data

          if (creditCardResponse.data.data.length === 0) {
            this.isEmptyCreditCard = true
          }
          this.creditCard = creditCardResponse.data.data

          if (this.isEmptyBank && this.isEmptyCreditCard) {
            this.$router.push('/user/bank/create')
          }

          if (this.creditCard && this.creditCard.length) {
            this.activeTab = 'credit'
          } else if (this.getTypeList(1).length) {
            this.activeTab = 'bank'
          } else if (this.getTypeList(3).length) {
            this.activeTab = 'crypto'
          } else if (this.getTypeList(2).length) {
            this.activeTab = 'ewallet'
          }
        })
        .catch(error => {
          console.error('Error:', error)
        })
    },
    changeTab(tab) {
      this.activeTab = tab

      this.$nextTick(() => {
        scrollToActive(this.$refs['tab'])
      })
    },
    getTypeList(type) {
      return this.list.filter((item) => item.bank_type === type)
    },
    showOnlyFiveNum(num) {
      return num.slice(-5)
    },
    showModal(id, type = 'bank') {
      this.deleteCardId = id
      this.deleteCardType = type
      this.showVerifyPopup = true
    },
    closeVerifyPopup() {
      this.showVerifyPopup = false
      this.deleteCardId = null
      this.deleteCardType = null
    },
    handleDelete(verifyCode) {
      const deleteApi = this.deleteCardType === 'credit' ? deleteCreditCard : deleteBankCard

      deleteApi({ id: this.deleteCardId, verify_code: verifyCode, verify_type: 'memberBank' }).then(response => {
        const msg = this.deleteCardType === 'credit'
          ? response.data.data.message
          : response.data.msg
        showNotice(msg)

        this.closeVerifyPopup()
        this.getList()
      }).catch(error => {
        this.$refs.verifyCode.setServerError(error.response)
      })
    }
  }
}
</script>
